export const googlePlaceApi = async (payload) => {
	try {
		return fetch(
			`${process.env.REACT_APP_BASE_URL}/sellers/google/location?input=${payload}`
		).then((res) => res.json());
	} catch (err) {
		return err;
	}
};
